import { partners, loading, modal, toast, customer, fe, sp, auth, user } from '../types';
import { takeLatest, put, call, all, select } from 'redux-saga/effects';
import { getLoggedUser } from '../selectors/users';
import { getPartnerFilterDetails } from '../selectors/partners';
import { getCustomerIdOfLoginUser } from '../utils/utils';
import { allUserTab } from '../pages/team/TeamController';
import { isUserScogoMember, ScogoID, uploadFileToS3WithSignedUrl } from '../utils/common';
import scogo_apis from '../scogo_apis';
import { allusersTab, verificationPendingTab } from '../pages/users/controller';

export function* getPartnerList(action) {
    const { limit = 10, page = 1, query, columns, sortBy = 'tickets_executed', sortOrder = -1, status, callDetails = true, dropdown, concat = false, org, tab, filterPayload, roles, source } = action.payload;

    yield put({ type: partners.SET_PARTNER_FILTER_PAYLOAD, payload: { limit, page, query, sortBy, sortOrder, status, dropdown, org, tab, filterPayload, roles, source } });

    const queryParams = {
        limit,
        page,
        ...filterPayload
    };

    if (columns) queryParams.select = columns;
    // if (sortBy) queryParams.sortBy = sortBy;
    // if (sortOrder) queryParams.sortOrder = sortOrder;
    if (query) queryParams.q = query;
    if (org) queryParams.org_id = org;
    const { rolesList } = yield select((state) => state.partners);
    let findRoles = undefined;
    if (roles) findRoles = roles
    if (!findRoles && tab && rolesList) {
        findRoles = rolesList.find(({ path }) => path === tab && ![allusersTab.path, verificationPendingTab.path].includes(tab));
    }
    if (findRoles) queryParams.role_id = findRoles.id;
    if (tab === allusersTab.path && rolesList?.length > 0) {
        queryParams.role_id = rolesList.map((elem) => elem.id).join(',');
    }
    if (tab === verificationPendingTab.path) queryParams.is_verified = false;

    const newLoggedUserData = yield select(state => state.auth.newLoggedUserData);
    const isScogoId = isUserScogoMember(newLoggedUserData.orgMemberships);

    if (!isScogoId) {
        queryParams.org_id = newLoggedUserData.org.id;
    }

    try {
        if (source !== 'addTeam') {

            yield put({ type: loading.PARTNERS_LIST_LOADING, payload: true });
        }
        const response = yield call(scogo_apis.user.getUsersList, {}, {}, queryParams, {});

        if (response.status === 200) {
            if (dropdown) {
                yield put({ type: partners.GET_PARTNER_LIST_DROPDOWN_SUCCESS, payload: { data: response.data.data, concat } });
            } else {
                yield put({ type: partners.GET_PARTNER_LIST_SUCCESS, payload: { ...response.data, tab } });
            }
            if (callDetails) {
                const user_ids = response.data.data.map((user) => user.id);
                // if (Array.isArray(legacy_ids) && legacy_ids.length > 0) {
                //     yield put({ type: partners.GET_PARTNER_DETAILS_LIST_REQUEST, payload: { userIds: legacy_ids, status } });
                // }
                if (Array.isArray(user_ids) && user_ids.length > 0) {
                    yield put({ type: user.GET_ADDITIONAL_DETAILS_REQUEST, payload: { user_ids } });
                }

            }
        } else {
            yield put({ type: partners.GET_PARTNER_LIST_FAILURE, payload: 'Something went wrong' });
            yield put({ type: toast.SEND_TOAST, payload: { status: 'danger', message: response.data.data.message || 'Something went wrong' } });
        }
    } catch (error) {
        yield put({ type: partners.GET_PARTNER_LIST_FAILURE, payload: error });
    }
    yield put({ type: loading.PARTNERS_LIST_LOADING, payload: false });
}

export function* getPartnerCount(action) {
    const { org_id } = action.payload;
    try {
        yield put({ type: loading.PARTNERS_COUNT_LOADING, payload: true });
        const response = yield call(scogo_apis.user.getUserCount, {}, {}, { org_id }, {});

        if (response.status === 200) {
            yield put({ type: partners.GET_PARTNER_COUNT_SUCCESS, payload: response.data.data });
        }
    } catch (error) {
        yield put({ type: partners.GET_PARTNER_COUNT_FAILURE, payload: error });
    }
    yield put({ type: loading.PARTNERS_COUNT_LOADING, payload: false });
}

export function* getPartnerFilterList(action) {
    const { roles, filter_labels = 'full_name,email,mobile,status,territories', tab } = action.payload;
    let queryParams = { filter_labels };
    const { rolesList } = yield select((state) => state.partners);
    let findRoles = undefined;
    if (roles) findRoles = roles
    if (!findRoles && tab && rolesList) {
        findRoles = rolesList.find(({ path }) => path === tab && ![allusersTab.path, verificationPendingTab.path].includes(tab));
    }
    if (findRoles) queryParams.role_id = findRoles.id;

    try {
        yield put({ type: loading.PARTNERS_LIST_COUNT_LOADING, payload: true });
        const response = yield call(scogo_apis.user.userFilterList, {}, {}, queryParams, {});
        if (response.status === 200) {
            yield put({ type: partners.GET_PARTNER_FILTER_SUCCESS, payload: response.data.data });
        }
    } catch (error) {
        yield put({ type: partners.GET_PARTNER_FILTER_FAILURE, payload: error });
    }
    yield put({ type: loading.PARTNERS_LIST_COUNT_LOADING, payload: false });
}

export function* refreshTeamTable(action) {
    const partnerFilterPayload = yield select(state => state.partners.partnerFilterPayload);

    try {
        const payload = {
            ...partnerFilterPayload
        }
        yield put({ type: partners.GET_PARTNER_LIST_REQUEST, payload: payload });
    } catch (err) {
        yield put({ type: partners.REFRESH_PARTNER_FILTER_FAILURE, payload: err });
    }
}

export function* getRolesList(action) {

    const { select: select_data, org_id, source, self_onboard, invite, check_org = true } = action.payload;

    const newLoggedUserData = yield select(state => state.auth.newLoggedUserData);

    try {
        const queryParams = { select: select_data, self_onboard, org_id, limit: 100 };
        if (check_org && newLoggedUserData.org.id === org_id) delete queryParams.org_id;
        if (invite) queryParams.invite = invite;
        yield put({ type: loading.USERS_ACCESSIBLE_ROLES_LIST_LOADING, payload: true });
        const response = yield call(scogo_apis.user.getRolesList, {}, {}, queryParams)

        if (response.status === 200) {
            if (source === 'onboard') {
                yield put({ type: auth.GET_ROLES_LIST_ONBOARD, payload: response.data.data })
            } else if (source === 'invite') {
                yield put({ type: partners.ROLES_INVITE_LIST_SUCCESS, payload: response.data.data })
            } else {
                yield put({ type: partners.GET_TEAMS_ROLES_SUCCESS, payload: response.data.data })
            }
        }

    } catch (error) {
        yield put({ type: partners.GET_TEAMS_ROLES_FAILURE, payload: { message: error } })
    }
    yield put({ type: loading.USERS_ACCESSIBLE_ROLES_LIST_LOADING, payload: false });
}


export default function* partnersSaga() {
    yield takeLatest(partners.GET_PARTNER_LIST_REQUEST, getPartnerList);
    yield takeLatest(partners.GET_PARTNER_COUNT_REQUEST, getPartnerCount);
    yield takeLatest(partners.GET_PARTNER_FILTER_REQUEST, getPartnerFilterList);
    yield takeLatest(partners.REFRESH_PARTNER_FILTER_REQUEST, refreshTeamTable);
    yield takeLatest(partners.GET_TEAMS_ROLES_REQUEST, getRolesList)
}
